import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { testimonials } from '@/mocks/movies';

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "八戒影院",
  "url": "https://bajiecinema.com/",
  "description": "电影大全免费观看，高清不缓冲。最新热门影片与电视剧全集同步更新，在线畅看。",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "建国路88号八戒影视大厦",
    "addressLocality": "北京",
    "addressRegion": "朝阳区",
    "addressCountry": "CN"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+86-400-000-0000",
    "contactType": "customer service",
    "areaServed": "CN",
    "availableLanguage": "Chinese"
  }
};

const aboutPageSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "name": "关于八戒影院 - 品牌介绍与口碑评价",
  "description": "八戒影院成立于2020年，专注于为用户提供高品质影视内容的在线平台。了解八戒影院的品牌故事、用户口碑和联系方式。",
  "url": "https://bajiecinema.com/about"
};

export default function About() {
  return (
    <div className="min-h-screen bg-background-50 pt-16">
      <SchemaOrg data={orgSchema} />
      <SchemaOrg data={aboutPageSchema} />
      <div className="w-full px-4 md:px-6 py-6">
        <div className="max-w-[1000px] mx-auto">
          <Breadcrumb items={[{ label: '关于我们' }]} />

          <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-8">
            关于八戒影院
          </h1>

          <section className="mb-12">
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="flex-1">
                <h2 className="text-lg font-semibold text-foreground-900 mb-4">品牌介绍</h2>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  八戒影院成立于2020年，是一家专注于为用户提供高品质影视内容的在线平台。我们致力于打造国内领先的<strong>电影大全免费观看</strong>网站，让每一位用户都能享受到<strong>高清不缓冲</strong>的观影体验。平台涵盖最新热门影片、经典电影、热门电视剧等多种类型，资源丰富，每日同步更新。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  自成立以来，八戒影院始终坚持"免费、高清、全面"的服务理念。我们拥有专业的内容运营团队，全天候追踪全球影视动态，确保平台上的<strong>免费电影</strong>和<strong>电视剧全集</strong>始终处于<strong>同步更新</strong>状态。无论是好莱坞大片、国产新片，还是日韩欧美剧集，用户都能在这里找到心仪的内容。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  我们的技术团队不断优化播放体验，采用先进的视频编码和CDN分发技术，确保<strong>在线观看</strong>时画面清晰流畅，真正实现<strong>高清不缓冲</strong>的观影承诺。同时，简约直观的界面设计让每一位用户都能轻松上手，快速找到想看的影片。
                </p>
              </div>
              <div className="lg:w-[350px] flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20cinema%20theater%20interior%20with%20warm%20golden%20red%20ambient%20lighting%20comfortable%20seats%20large%20screen%20showing%20vibrant%20movie%20scene%20luxurious%20atmosphere%20cinematic%20photography%20style&width=700&height=500&seq=about-cinema-2026&orientation=landscape"
                  alt="八戒影院品牌形象"
                  className="w-full rounded-xl object-cover"
                />
              </div>
            </div>
          </section>

          <section className="mb-12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-background-100 rounded-lg p-6">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-100 text-primary-500 rounded-lg mb-4">
                  <i className="ri-focus-2-line text-xl"></i>
                </div>
                <h2 className="text-base font-semibold text-foreground-900 mb-3">我们的使命</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  让每一个热爱影视的人都能轻松找到并观看自己喜欢的作品，无需付费，无需等待，高清流畅，随时随地。我们希望通过优质的内容和流畅的体验，让观影成为一种纯粹的享受，让更多人感受到影视艺术的魅力。
                </p>
              </div>
              <div className="bg-background-100 rounded-lg p-6">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 text-accent-600 rounded-lg mb-4">
                  <i className="ri-eye-line text-xl"></i>
                </div>
                <h2 className="text-base font-semibold text-foreground-900 mb-3">我们的愿景</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  成为中国最受欢迎的免费影视内容平台，以海量资源、极致画质和流畅体验赢得用户的信赖与喜爱。打造一个覆盖电影、电视剧、动漫、纪录片等全品类的一站式免费观影生态。
                </p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-lg font-semibold text-foreground-900 mb-6">口碑评价</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {testimonials.map((t, index) => (
                <div key={index} className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <div key={i} className={`w-3.5 h-3.5 flex items-center justify-center ${i < t.rating ? 'text-accent-500' : 'text-foreground-300'}`}>
                        <i className="ri-star-fill text-xs"></i>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "{t.text}"
                  </p>
                  <p className="text-xs text-foreground-500 font-medium">— {t.name}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold text-foreground-900 mb-6">联系我们</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-background-100 rounded-lg p-5">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-100 text-primary-500 rounded-lg mb-3">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <h3 className="text-xs text-foreground-500 mb-1">电子邮箱</h3>
                <p className="text-sm font-medium text-foreground-800">service@bajiecinema.com</p>
              </div>
              <div className="bg-background-100 rounded-lg p-5">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-100 text-primary-500 rounded-lg mb-3">
                  <i className="ri-phone-line text-lg"></i>
                </div>
                <h3 className="text-xs text-foreground-500 mb-1">客服电话</h3>
                <p className="text-sm font-medium text-foreground-800">400-000-0000</p>
              </div>
              <div className="bg-background-100 rounded-lg p-5">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-100 text-primary-500 rounded-lg mb-3">
                  <i className="ri-map-pin-line text-lg"></i>
                </div>
                <h3 className="text-xs text-foreground-500 mb-1">公司地址</h3>
                <p className="text-sm font-medium text-foreground-800">北京市朝阳区建国路88号八戒影视大厦</p>
              </div>
              <div className="bg-background-100 rounded-lg p-5">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-100 text-primary-500 rounded-lg mb-3">
                  <i className="ri-wechat-line text-lg"></i>
                </div>
                <h3 className="text-xs text-foreground-500 mb-1">微信公众号</h3>
                <p className="text-sm font-medium text-foreground-800">八戒影院官方</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}